var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMasterData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 4.4C14.4 5.72548 11.5346 6.8 7.99997 6.8C4.46535 6.8 1.59998 5.72548 1.59998 4.4M14.4 4.4C14.4 3.07452 11.5346 2 7.99997 2C4.46535 2 1.59998 3.07452 1.59998 4.4M14.4 4.4V11.6C14.4 12.9255 11.5346 14 7.99997 14C4.46535 14 1.59998 12.9255 1.59998 11.6V4.4M14.4 8C14.4 9.32548 11.5346 10.4 7.99997 10.4C4.46535 10.4 1.59998 9.32548 1.59998 8",
    stroke: "#757575",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterData);
export default __webpack_public_path__ + "static/media/masterData.13139b911d7f781a86d27034fbb75be0.svg";
export { ForwardRef as ReactComponent };